import { ExerciseDTO, UserDTO } from '@/generated';
import { Role } from '@/models/user';
import { pathMap } from '@/navigation/paths';
import { enqueueSnackbar } from 'notistack';

export const isExerciseEditor = (exercise?: ExerciseDTO, user?: UserDTO) =>
  !exercise ? false : exercise?.creatorId === user?.userId || user?.roles.includes(Role.Admin) || exercise?.editorIds?.includes(user?.userId ?? '');

export const copyExerciseLinkToClipboard = (exerciseId: string) => {
  const target = `${process.env.REACT_APP_PUBLIC_URL}${pathMap.ExerciseDetails}/${exerciseId}`;
  navigator.clipboard.writeText(target);
  enqueueSnackbar(`Link to ${target} copied to clipboard.`, { variant: 'default' });
};

export const findRelatedExercises = (progressionExerciseIds: string[], regressionExerciseIds: string[], exercises: ExerciseDTO[]) => {
  const relatedExerciseIds = new Set([...progressionExerciseIds, ...regressionExerciseIds]);
  return exercises.filter((exercise) => relatedExerciseIds.has(exercise.id));
};
